<template>
  <a class="button-app">
    <div class="button-app__icon">
      <slot name="icon" />
    </div>
    <div class="button-app__text">
      <span>
        <slot />
      </span>
      <span class="button-app__text-bold">
        <slot name="name" />
      </span>
    </div>
  </a>
</template>

<style lang="scss" scoped>
.button-app {
  padding: 10px 12px;
  border-radius: 12px;
  background-color: black;
  display: flex;
  gap: 10px;
  white-space: pre-line;
  text-align: start;
  border: 1px solid $ui-gray-3;

  &__icon {
    flex-shrink: 0;
    width: 38px;
    height: 38x;
  }

  &__text {
    display: flex;
    flex-direction: column;
    @include h6-2;
    color: $white;

    &-bold {
      @include h3-5;
    }
  }
}
</style>
